import React from "react";
import styled from "styled-components";
import TextRenderer from "./TextRenderer";
import smallLogo from "../../Assets/Farazandishan-logo-2.png"

const Style = styled.div`
    display: flex;
    position: relative;
    isolation: isolate;
    margin: 1rem 0;
    &.rtl {
        .bg-image {
            inset: 0 70px 0 50%;
        }
        .data {
            .title {
                margin: 0 2rem 0 0;
            }
            .subtitle {
                margin: 0 2rem 0 0;
            }
        }
        &.right {
            .bg-image {
                inset: 0 50% 0 70px;
            }
            .data {
                flex-direction: row-reverse;
            }
        }
    }
    .bg-image {
        z-index: 1;
        position: absolute;
        inset: 0 50% 0 70px;
        border-radius: 1rem;
        overflow: hidden;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }
    }
    .cover {
        z-index: 2;
        position: absolute;
        inset: 0;
        background-color: #00000088;
    }
    .data {
        z-index: 3;
        width: calc(100% - 140px);
        padding: 5rem 70px 5rem;
        gap: 0;
        display: flex;
        flex-direction: row;
        justify-content: end;
        align-items: c;
        .column {
            width: 40%;
        }
        .title {
            font-size: 2rem;
            font-weight: 800;
            color: #fff;
            margin: 0 0 0 2rem;
        }
        .subtitle {
            font-size: 1.5rem;
            font-weight: 500;
            color: #fff;
            margin: 0 0 0 2rem;
        }
        .box {
            width: 60%;
            position: relative;
            background-color: #f5faff;
            box-shadow: var(--n-shadow-1);
            padding: 2rem;
            border-radius: 8px;
            display: flex;
            flex-direction: column;
            overflow: hidden;
        }
    }
    &.right {
        .bg-image {
            inset: 0 70px 0 50%;
        }
        .data {
            flex-direction: row-reverse;
        }
    }
    @media (max-width: 850px){
        &.rtl {
            .bg-image {
                inset: 0 1rem 50% 1rem;
            }
            .data {
                .title {
                    margin: 0 2rem 0 0;
                }
                .subtitle {
                    margin: 0 2rem 0 0;
                }
            }
            &.right {
                .bg-image {
                    inset: 0 1rem 50% 1rem;
                }
                .data {
                    flex-direction: column;
                }
            }
        }
        .bg-image {
            inset: 0 1rem 50% 1rem;
        }
        .data { 
            flex-direction: column;
            width: calc(100% - 32px);
            padding: 3rem 16px 3rem;
            gap: 1rem;
            .column {
                width: 100%;
            }
            .box {
                width: calc(100% - 4rem);
                margin: 0 1rem;
                padding: 2rem 1rem;
            }
        }
        &.right {
            .bg-image {
                inset: 0 1rem 50% 1rem;
            }
            .data {
                flex-direction: column;
            }
        }
    }
`;

export default function ParagraphBox2({pageHeight, data,  language}) {
    return (
      <Style className={data.align + " " +  language.dir}>
        <div className="bg-image">
            <img src={data.data.bgimage} alt={data.title}/>
            <div className="cover">
            </div>
        </div>
        
        <div className="data">
            <div className="column">
                <div className="title">
                    {data.data.title}
                </div>
                <div className="subtitle">
                    {data.data.subtitle}
                </div>
            </div>
            <div className="box">
                <TextRenderer data={data.data.text}/>
            </div>
        </div>
      </Style>
  );
}
